import { render, staticRenderFns } from "./products.html?vue&type=template&id=d2226176&scoped=true&"
import script from "./products.js?vue&type=script&lang=js&"
export * from "./products.js?vue&type=script&lang=js&"
import style0 from "./products.scss?vue&type=style&index=0&id=d2226176&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2226176",
  null
  
)

export default component.exports